/**
 * Localised strings for the Smart In-App Review Modal.
 * 13 supported languages: en, ar, ur, zh, fa, tr, fr, bn, id, es, pt, de, it.
 */

const REVIEW_STRINGS = {
  en: {
    title: 'Enjoying Falak?',
    subtitle: 'Your review helps us reach more Muslims worldwide',
    rateHuawei: 'Rate on AppGallery',
    rateGoogle: 'Rate on Google Play',
    rateIos: 'Rate on App Store',
    rateFallbackWeb: 'Rate on your store',
    chooseStore: 'Choose your store',
    later: 'Maybe later',
    never: "Don't ask again",
    thanksTitle: 'Thank you!',
    thanksBody: 'Your support means the world to us.',
    menuLabel: 'Rate the App',
    hint: '5 stars ⭐ take only 10 seconds',
  },
  ar: {
    title: 'هل تستمتع بتطبيق فلك؟',
    subtitle: 'تقييمك يساعدنا في الوصول إلى المزيد من المسلمين حول العالم',
    rateHuawei: 'قيّم على متجر هواوي',
    rateGoogle: 'قيّم على Google Play',
    rateIos: 'قيّم على App Store',
    rateFallbackWeb: 'قيّم على متجرك',
    chooseStore: 'اختر متجرك',
    later: 'ربما لاحقاً',
    never: 'لا تسألني مرة أخرى',
    thanksTitle: 'شكراً لك!',
    thanksBody: 'دعمك يعني لنا الكثير.',
    menuLabel: 'قيّم التطبيق',
    hint: '5 نجوم ⭐ تستغرق 10 ثوانٍ فقط',
  },
  ur: {
    title: 'کیا آپ کو فلک پسند ہے؟',
    subtitle: 'آپ کی رائے دنیا بھر کے مسلمانوں تک ہماری رسائی میں مدد کرتی ہے',
    rateHuawei: 'AppGallery پر ریٹنگ دیں',
    rateGoogle: 'Google Play پر ریٹنگ دیں',
    rateIos: 'App Store پر ریٹنگ دیں',
    rateFallbackWeb: 'اپنے اسٹور پر ریٹنگ دیں',
    chooseStore: 'اپنا اسٹور منتخب کریں',
    later: 'شاید بعد میں',
    never: 'دوبارہ نہ پوچھیں',
    thanksTitle: 'شکریہ!',
    thanksBody: 'آپ کی حمایت ہمارے لیے بہت اہم ہے۔',
    menuLabel: 'ایپ کی درجہ بندی کریں',
    hint: '5 ستارے ⭐ صرف 10 سیکنڈ لیتے ہیں',
  },
  zh: {
    title: '喜欢 Falak 吗？',
    subtitle: '您的评价能帮助我们触达世界各地的穆斯林',
    rateHuawei: '在 AppGallery 评分',
    rateGoogle: '在 Google Play 评分',
    rateIos: '在 App Store 评分',
    rateFallbackWeb: '在您的商店评分',
    chooseStore: '选择您的商店',
    later: '稍后再说',
    never: '不再询问',
    thanksTitle: '谢谢！',
    thanksBody: '您的支持对我们意义非凡。',
    menuLabel: '给应用评分',
    hint: '5 星 ⭐ 只需 10 秒',
  },
  fa: {
    title: 'از فلک لذت می‌برید؟',
    subtitle: 'نظر شما به ما کمک می‌کند تا به مسلمانان بیشتری در سراسر جهان برسیم',
    rateHuawei: 'در AppGallery امتیاز دهید',
    rateGoogle: 'در Google Play امتیاز دهید',
    rateIos: 'در App Store امتیاز دهید',
    rateFallbackWeb: 'در فروشگاه خود امتیاز دهید',
    chooseStore: 'فروشگاه خود را انتخاب کنید',
    later: 'شاید بعداً',
    never: 'دوباره نپرس',
    thanksTitle: 'متشکریم!',
    thanksBody: 'حمایت شما برای ما بسیار ارزشمند است.',
    menuLabel: 'به برنامه امتیاز دهید',
    hint: '۵ ستاره ⭐ فقط ۱۰ ثانیه طول می‌کشد',
  },
  tr: {
    title: "Falak'tan hoşlanıyor musunuz?",
    subtitle: 'Yorumunuz dünya çapında daha fazla Müslümana ulaşmamıza yardımcı olur',
    rateHuawei: "AppGallery'de değerlendir",
    rateGoogle: "Google Play'de değerlendir",
    rateIos: "App Store'da değerlendir",
    rateFallbackWeb: 'Mağazanızda değerlendirin',
    chooseStore: 'Mağazanızı seçin',
    later: 'Belki sonra',
    never: 'Bir daha sorma',
    thanksTitle: 'Teşekkürler!',
    thanksBody: 'Desteğiniz bizim için çok değerli.',
    menuLabel: 'Uygulamayı Değerlendir',
    hint: '5 yıldız ⭐ yalnızca 10 saniye alır',
  },
  fr: {
    title: 'Vous aimez Falak ?',
    subtitle: 'Votre avis nous aide à toucher plus de musulmans dans le monde',
    rateHuawei: "Noter sur AppGallery",
    rateGoogle: 'Noter sur Google Play',
    rateIos: "Noter sur l'App Store",
    rateFallbackWeb: 'Noter sur votre store',
    chooseStore: 'Choisissez votre store',
    later: 'Plus tard',
    never: 'Ne plus demander',
    thanksTitle: 'Merci !',
    thanksBody: 'Votre soutien compte énormément pour nous.',
    menuLabel: "Noter l'application",
    hint: '5 étoiles ⭐ ne prennent que 10 secondes',
  },
  bn: {
    title: 'Falak উপভোগ করছেন?',
    subtitle: 'আপনার রিভিউ আমাদের সারা বিশ্বের আরও মুসলিমদের কাছে পৌঁছাতে সহায়তা করে',
    rateHuawei: 'AppGallery-তে রেটিং দিন',
    rateGoogle: 'Google Play-তে রেটিং দিন',
    rateIos: 'App Store-এ রেটিং দিন',
    rateFallbackWeb: 'আপনার স্টোরে রেটিং দিন',
    chooseStore: 'আপনার স্টোর বেছে নিন',
    later: 'হয়তো পরে',
    never: 'আর জিজ্ঞেস করবেন না',
    thanksTitle: 'ধন্যবাদ!',
    thanksBody: 'আপনার সমর্থন আমাদের কাছে অমূল্য।',
    menuLabel: 'অ্যাপ রেট করুন',
    hint: '৫ তারা ⭐ মাত্র ১০ সেকেন্ড লাগে',
  },
  id: {
    title: 'Menikmati Falak?',
    subtitle: 'Ulasan Anda membantu kami menjangkau lebih banyak Muslim di seluruh dunia',
    rateHuawei: 'Beri Nilai di AppGallery',
    rateGoogle: 'Beri Nilai di Google Play',
    rateIos: 'Beri Nilai di App Store',
    rateFallbackWeb: 'Beri Nilai di store Anda',
    chooseStore: 'Pilih store Anda',
    later: 'Mungkin nanti',
    never: 'Jangan tanya lagi',
    thanksTitle: 'Terima kasih!',
    thanksBody: 'Dukungan Anda sangat berarti bagi kami.',
    menuLabel: 'Beri Nilai Aplikasi',
    hint: '5 bintang ⭐ hanya butuh 10 detik',
  },
  es: {
    title: '¿Disfrutas Falak?',
    subtitle: 'Tu valoración nos ayuda a llegar a más musulmanes en todo el mundo',
    rateHuawei: 'Valorar en AppGallery',
    rateGoogle: 'Valorar en Google Play',
    rateIos: 'Valorar en App Store',
    rateFallbackWeb: 'Valorar en tu tienda',
    chooseStore: 'Elige tu tienda',
    later: 'Quizás luego',
    never: 'No volver a preguntar',
    thanksTitle: '¡Gracias!',
    thanksBody: 'Tu apoyo significa muchísimo para nosotros.',
    menuLabel: 'Valorar la App',
    hint: '5 estrellas ⭐ toman solo 10 segundos',
  },
  pt: {
    title: 'Está gostando do Falak?',
    subtitle: 'A sua avaliação nos ajuda a alcançar mais muçulmanos pelo mundo',
    rateHuawei: 'Avaliar na AppGallery',
    rateGoogle: 'Avaliar no Google Play',
    rateIos: 'Avaliar na App Store',
    rateFallbackWeb: 'Avaliar na sua loja',
    chooseStore: 'Escolha a sua loja',
    later: 'Talvez mais tarde',
    never: 'Não perguntar novamente',
    thanksTitle: 'Obrigado!',
    thanksBody: 'O seu apoio significa muito para nós.',
    menuLabel: 'Avaliar o App',
    hint: '5 estrelas ⭐ levam apenas 10 segundos',
  },
  de: {
    title: 'Gefällt Ihnen Falak?',
    subtitle: 'Ihre Bewertung hilft uns, mehr Muslime weltweit zu erreichen',
    rateHuawei: 'In AppGallery bewerten',
    rateGoogle: 'In Google Play bewerten',
    rateIos: 'Im App Store bewerten',
    rateFallbackWeb: 'In Ihrem Store bewerten',
    chooseStore: 'Wählen Sie Ihren Store',
    later: 'Vielleicht später',
    never: 'Nicht mehr fragen',
    thanksTitle: 'Vielen Dank!',
    thanksBody: 'Ihre Unterstützung bedeutet uns sehr viel.',
    menuLabel: 'App bewerten',
    hint: '5 Sterne ⭐ dauern nur 10 Sekunden',
  },
  it: {
    title: 'Ti piace Falak?',
    subtitle: 'La tua recensione ci aiuta a raggiungere più musulmani nel mondo',
    rateHuawei: 'Valuta su AppGallery',
    rateGoogle: 'Valuta su Google Play',
    rateIos: 'Valuta su App Store',
    rateFallbackWeb: 'Valuta sul tuo store',
    chooseStore: 'Scegli il tuo store',
    later: 'Forse più tardi',
    never: 'Non chiedere più',
    thanksTitle: 'Grazie!',
    thanksBody: 'Il tuo supporto significa moltissimo per noi.',
    menuLabel: 'Valuta l\'App',
    hint: '5 stelle ⭐ richiedono solo 10 secondi',
  },
};

export function getReviewStrings(lang) {
  return REVIEW_STRINGS[lang] || REVIEW_STRINGS.en;
}
